import(/* webpackMode: "eager" */ "/home/runner/work/terzotempo/terzotempo/node_modules/next/dist/client/app-dir/link.js");
